import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1AdminPrivilegeIDOCToArray} from "../../../../util/Payload";

class AdminPrivilegeEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.AdminPrivilege-001";

        let foreignKeyName = "";

        let fk = {};
        if (this.enterpriseObject !== null) {
            if (this.enterpriseObject.getName() === "AdminPrivilege") {
                foreignKeyName = "USID";
            }
            fk[foreignKeyName] = foreignKey;
        }

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/admin_privileges",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                ...(foreignKey ? fk : {}),
                ...this.getSearchSpecification(),
            },
            headers: {
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1AdminPrivilegeIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

}

export default AdminPrivilegeEnterpriseComponent;